import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";
import CheckIcon from "ui/modules/fleet/vehicles/pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleEditCard/components/VehicleWizardIntro/scenes/CheckIcon";

import { DAMAGE_INTRO_SAMPLE } from "../consts";
import { DamageSceneProps } from "../types";

/** Korak "Dokumentacija": priloženi dokumenti, fotografije s oznakama i sve uz jednu štetu. */
const DamageDocumentsScene: React.FC<DamageSceneProps> = ({ formValues }) => {
  const uploadedNames = formValues.documentUploads.map((upload) => upload.originalFileName);
  const documents = uploadedNames.length > 0 ? uploadedNames : DAMAGE_INTRO_SAMPLE.documents;
  const photoCount = formValues.photoUploads.length;
  const pinCount = formValues.pins.length;

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Dokumentacija štete</div>
          <div className="text-sm font-bold text-slate-800 truncate">{formValues.name || DAMAGE_INTRO_SAMPLE.name}</div>
          <div className="mt-3 space-y-2">
            {documents.slice(0, 4).map((document) => (
              <div key={document} className="flex items-center gap-2 rounded-md bg-slate-50 px-2 py-2">
                <span className="flex items-center justify-center w-6 h-7 rounded-sm bg-rose-50 text-[0.5rem] font-bold text-rose-500 flex-shrink-0">
                  PDF
                </span>
                <span className="flex-1 text-[0.7rem] font-medium text-slate-700 truncate">{document}</span>
                <CheckIcon />
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Fotografije</div>
          <div className="mt-3 grid grid-cols-3 gap-1.5">
            {[0, 1, 2].map((index) => (
              <div key={index} className="relative h-10 rounded-sm bg-gradient-to-br from-slate-100 to-slate-200 p-1">
                <img src={DAMAGE_INTRO_SAMPLE.image} alt="" className="w-full h-full object-contain" />
                {index === 0 && (
                  <span className="absolute left-1/3 top-1/2 w-2 h-2 rounded-full border border-white bg-rose-500" />
                )}
              </div>
            ))}
          </div>
          <div className="mt-3 text-[0.65rem] text-slate-400">
            {photoCount > 0 ? `${photoCount} fotografija` : "Fotografije s oznakama"}
            {pinCount > 0 ? ` · ${pinCount} oznaka` : ""}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Sve uz štetu na jednom mjestu"
          subtitle="Prijava, fotografije i dokumenti"
          iconClassName="bg-blue-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#1D4ED8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8zM14 2v6h6" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(DamageDocumentsScene);
